import { Component, inject, input, model, output } from '@angular/core';
import { TranslateService } from '@devinforius/super-compos-17';

@Component({
  selector: 'idel-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
})
export class ConfirmDialogComponent {
  private readonly translater = inject(TranslateService);

  public readonly open = model.required<boolean>();
  public readonly message = input<string>(this.translater.translate('global.confirmMessage'));
  public readonly header = input<string>(this.translater.translate('global.confirmHeader'));

  public readonly onConfirm = output<void>();
  public readonly onCancel = output<void>();

  public closeDialog(): void {
    this.open.set(false);
    this.onCancel.emit();
  }

  public cancel(): void {
    this.closeDialog();
  }

  public confirm(): void {
    this.open.set(false);
    this.onConfirm.emit();
  }
}
